import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { colors } from 'ui/theme/colors';

export const ZeroStateList = ({ height = 128, width = 128, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      data-test="zero-state-list"
      height={height}
      width={width}
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        d="M12.8 64C12.8 77.5791 18.1943 90.6021 27.7961 100.204C37.398 109.806 50.4209 115.2 64 115.2C77.5791 115.2 90.602 109.806 100.204 100.204C109.806 90.6021 115.2 77.5791 115.2 64C115.2 50.421 109.806 37.398 100.204 27.7962C90.602 18.1943 77.5791 12.8 64 12.8C50.4209 12.8 37.398 18.1943 27.7961 27.7962C18.1943 37.398 12.8 50.421 12.8 64Z"
        fill={colors.backgroundTertiary}
      />
      <path
        d="M50.5728 102.044C50.5728 102.576 51.9814 103.086 54.4887 103.462C56.996 103.839 60.3966 104.05 63.9424 104.05C67.4882 104.05 70.8888 103.839 73.3961 103.462C75.9034 103.086 77.312 102.576 77.312 102.044C77.312 101.512 75.9034 101.002 73.3961 100.626C70.8888 100.25 67.4882 100.038 63.9424 100.038C60.3966 100.038 56.996 100.25 54.4887 100.626C51.9814 101.002 50.5728 101.512 50.5728 102.044Z"
        fill={colors.grey15}
      />
      <path
        d="M96.0883 33.1135C96.0883 32.2818 95.7579 31.4842 95.1698 30.8961C94.5817 30.3079 93.784 29.9775 92.9523 29.9775H37.6077C36.776 29.9775 35.9783 30.3079 35.3902 30.8961C34.8021 31.4842 34.4717 32.2818 34.4717 33.1135V88.4595C34.4717 89.2912 34.8021 90.0888 35.3902 90.6769C35.9783 91.2651 36.776 91.5955 37.6077 91.5955H78.4947C87.5661 88.1804 93.7114 82.4409 96.0883 73.7305V33.1135Z"
        fill={colors.white}
      />
      <path
        d="M48.2266 29.9775H37.6026C37.1907 29.9775 36.7829 30.0587 36.4025 30.2163C36.022 30.3739 35.6763 30.6048 35.3851 30.8961C35.0939 31.1873 34.8629 31.533 34.7053 31.9134C34.5477 32.2939 34.4666 32.7017 34.4666 33.1135V88.4595C34.4666 88.8713 34.5477 89.2791 34.7053 89.6596C34.8629 90.04 35.0939 90.3857 35.3851 90.6769C35.6763 90.9682 36.022 91.1991 36.4025 91.3567C36.7829 91.5143 37.1907 91.5955 37.6026 91.5955H48.2266V29.9775Z"
        fill={colors.purple20}
      />
      <path
        d="M96.0883 33.1135C96.0883 32.2818 95.7579 31.4842 95.1698 30.8961C94.5817 30.3079 93.784 29.9775 92.9523 29.9775H37.6077C36.776 29.9775 35.9783 30.3079 35.3902 30.8961C34.8021 31.4842 34.4717 32.2818 34.4717 33.1135V88.4595C34.4717 89.2912 34.8021 90.0888 35.3902 90.6769C35.9783 91.2651 36.776 91.5955 37.6077 91.5955H78.4947C87.5661 88.1804 93.7114 82.4409 96.0883 73.7305V33.1135Z"
        stroke={colors.purple100}
        strokeWidth="1.28"
      />
      <path d="M34.4717 79.2717H81.8099" stroke={colors.purple100} strokeWidth="1.28" />
      <path
        d="M78.4947 91.5956C78.4947 91.5956 83.5072 86.3476 81.2902 75.346C81.2531 75.1607 81.2557 74.9697 81.2977 74.7854C81.3397 74.6012 81.4202 74.4279 81.534 74.277C81.6478 74.1261 81.7922 74.001 81.9578 73.9099C82.1234 73.8189 82.3064 73.7639 82.4947 73.7486C93.0854 72.8999 96.0883 73.7307 96.0883 73.7307C93.7114 82.4411 87.5661 88.1806 78.4947 91.5956Z"
        fill={colors.purple20}
        stroke={colors.purple100}
        strokeWidth="1.28"
      />
      <path d="M48.2266 29.9775V91.5955" stroke={colors.purple100} strokeWidth="1.28" />
      <path d="M34.4717 42.3015H96.0883" stroke={colors.purple100} strokeWidth="1.28" />
      <path d="M34.4717 54.6252H96.0883" stroke={colors.purple100} strokeWidth="1.28" />
      <path d="M34.4717 66.9478H96.0883" stroke={colors.purple100} strokeWidth="1.28" />
    </SvgIcon>
  );
};
